module.exports = {
  messages: {
    ADVERTISING_DIGITAL_SERVICE_ACT_HEADLINE: '¿Por qué veo este anuncio?',
    ADVERTISING_DIGITAL_SERVICE_ACT_POP_UP_FOOTER_CTA: 'Más información',
    ADVERTISING_DIGITAL_SERVICE_ACT_POP_UP_FOOTER_MESSAGE:
      'sobre los criterios de grupo meta.',
    ADVERTISING_DIGITAL_SERVICE_ACT_POP_UP_MESSAGE:
      'Estás viendo este anuncio porque tu perfil responde a los criterios del anunciante.',
    ADVERTISING_LEAD_AD_FORM_CHECKBOX_ERROR: 'Marca la casilla para continuar',
    CARDS_SECTION_DESCRIPTION: 'Criterios de búsqueda frecuentes:',
    CARDS_SECTION_REGISTRATION_BUTTON_TEXT: 'Registrarme ahora',
    CARDS_SECTION_REGISTRATION_TEXT:
      'Únete a XING y multiplica tus opciones de búsqueda.',
    CARDS_SECTION_TITLE: 'Encuentra trabajo de forma inteligente',
    CAREER_HUB_TEASER_CARD_DESCRIPTION:
      'Accede a artículos interesantes y recibe consejo especializado de profesionales y expertos del sector.',
    CAREER_HUB_TEASER_CARD_TITLE: 'Descubre la guía profesional de XING',
    COMPANIES_SECTION_SUBTITLE:
      'Entra en contacto con más de 20 000 reclutadores y reclutadoras',
    COMPANIES_SECTION_TITLE:
      'Entra en contacto con más de 20 000 reclutadores y reclutadoras',
    CP_HIRING: 'Ofertas disponibles',
    'CP_TOP_COMPANIES_CARD_BUTTON.one': 'Ver {value} oferta',
    'CP_TOP_COMPANIES_CARD_BUTTON.other': 'Ver {value} ofertas',
    CP_TOP_COMPANIES_CARD_HIGHLIGHT:
      '{porcentaje} % ha recomendado a este empleador en kununu.',
    CRATE_LOSP_CAREER_HUB_CARD_DESCRIPTION:
      'Lee los mejores consejos y artículos de profesionales con amplia experiencia y expertos.',
    CRATE_LOSP_CAREER_HUB_CARD_TITLE: 'Guía de carreras profesionales de XING',
    CRATE_LOSP_COMPANIES_SECTION_SUBTITLE:
      'Consulta quién está contratando ahora.',
    CRATE_LOSP_COMPANIES_SECTION_TITLE:
      'Más de 270 000 empleadores están buscando personas como tú',
    CRATE_LOSP_CV_CARD_DESCRIPTION:
      'Crear una primera impresión perfecta y se genera en un momento.',
    CRATE_LOSP_CV_CARD_TITLE: 'Tu CV perfecto en formato PDF',
    CRATE_LOSP_PROFILE_CARD_DESCRIPTION:
      'Con tu perfil de XING las ofertas te llegan automáticamente y no dejarás escapar una buena oportunidad nunca más.',
    CRATE_LOSP_PROFILE_CARD_TITLE: 'Haz que las ofertas vengan a ti.',
    CRATE_LOSP_RECRUITERS_SECTION_SUBTITLE:
      'Contacta directamente con los profesionales de RR. HH. preferidos por la comunidad',
    CRATE_LOSP_RECRUITERS_SECTION_TITLE:
      'Más de 20 000 reclutadores buscando personal',
    CRATE_LOSP_REGISTER_BUTTON: 'Crear perfil',
    CRATE_LOSP_REGISTER_WITH_GOOGLE_BUTTON: 'Continuar con Google',
    DESCRIPTION_CARD_1: 'Trabaja donde mejor te sientes.',
    DESCRIPTION_CARD_2: 'Trabaja cuando quieras.',
    DESCRIPTION_CARD_3: 'Averigua en qué ofertas encajan tus cualidades.',
    DESCRIPTION_CARD_4: 'Cobra lo que te mereces.',
    DESCRIPTION_CARD_5: 'Guarda tiempo para lo importante en la vida.',
    DESCRIPTION_CARD_6: 'Por si quieres empezar poco a poco.',
    'DISCO_OBJECTS_FOLLOWER.one': 'seguidor',
    'DISCO_OBJECTS_FOLLOWER.other': 'seguidores',
    'DISCO_OBJECTS_FOLLOWER.zero': 'seguidores',
    ERROR_REGISTER_EMAIL_MAX_CHANGE:
      'Puedes cambiar tu dirección de correo electrónico un máximo de 10 veces.',
    JOBS_FIND_JOBS_RECRUITERS_LINK: '¿Publicar una oferta? <a>Hazlo aquí.</a>',
    JOBS_FIND_JOBS_RECRUITERS_LINK_FIRST_LINE: '¿Publicar una oferta?',
    JOBS_FIND_JOBS_RECRUITERS_LINK_SECOND_LINE: 'Hazlo aquí.',
    JOBS_FIND_JOBS_SEARCH_BUTTON: 'Buscar ofertas de empleo',
    JOBS_FIND_JOBS_SEARCH_LOCATION_PLACEHOLDER: 'Ubicación',
    JOBS_FIND_JOBS_SEARCH_PLACEHOLDER: 'Introducir el cargo',
    JOBS_FIND_JOBS_SEARCH_RADIUS_PLACEHOLDER: 'Radio',
    JOBS_FIND_JOBS_TITLE: 'Buscar ofertas',
    JOBS_JOB_TEASER_SAVE: 'Guardar oferta',
    JOBS_JOB_TEASER_SAVED: 'Guardado',
    JOBS_LANDING_LO_MARKETING_SEC_ONE_TEXT_ONE:
      'Más de 1 millón \nde ofertas de empleo',
    JOBS_LANDING_LO_MARKETING_SEC_ONE_TEXT_THREE:
      'Seminarios web sobre la búsqueda de empleo',
    JOBS_LANDING_LO_MARKETING_SEC_ONE_TEXT_TWO:
      'Más de 20 millones\nde usuarios y usuarias',
    JOBS_RECENT_SEARCH_EMPTY: 'Todas las ofertas de empleo',
    JOBS_SEARCH_AI_HEADLINE:
      'Describe a la IA de XING qué tipo de empleo quieres',
    JOBS_SEARCH_AI_INPUT_PLACEHOLDER_1: 'Describe tu trabajo ideal...',
    JOBS_SEARCH_AI_INPUT_PLACEHOLDER_10:
      'Incluye tus competencias y experiencia profesional',
    JOBS_SEARCH_AI_INPUT_PLACEHOLDER_2:
      'Añade una descripción en lenguaje sencillo...',
    JOBS_SEARCH_AI_INPUT_PLACEHOLDER_3:
      'Describe a grandes rasgos los trabajos que te gustan...',
    JOBS_SEARCH_AI_INPUT_PLACEHOLDER_4:
      'Enumera las ideas que tengas para tu próximo paso en tu carrera....',
    JOBS_SEARCH_AI_INPUT_PLACEHOLDER_5:
      'Puesto, nivel profesional, expectativas salariales',
    JOBS_SEARCH_AI_INPUT_PLACEHOLDER_6:
      'Todo aquello que es importante para tu vida profesional',
    JOBS_SEARCH_AI_INPUT_PLACEHOLDER_7: 'Cuanto más específico seas, mejor.',
    JOBS_SEARCH_AI_INPUT_PLACEHOLDER_8:
      'Trabajo parcial o a tiempo completo, trabajar desde casa, en la oficina o las dos...',
    JOBS_SEARCH_AI_INPUT_PLACEHOLDER_9:
      'Mejor emplear frases simples que palabras clave.',
    JOBS_SEARCH_AI_SALARY_SUGGESTION: 'Quiero ganar más dinero',
    JOBS_SEARCH_AI_SALARY_SUGGESTION_SUBTITLE:
      'Encuentra los trabajos más lucrativos',
    JOBS_SEARCH_AI_SWIMP_SUGGESTION: 'Buscar con mi perfil',
    JOBS_SEARCH_AI_SWIMP_SUGGESTION_SUBTITLE: 'Encuentra tu siguiente trabajo',
    JOBS_SEARCH_AI_SWIMS_SUGGESTION:
      'Ayuda para reorientar mi carrera profesional',
    JOBS_SEARCH_AI_SWIMS_SUGGESTION_SUBTITLE:
      'Descubre oportunidades profesionales totalmente nuevas con XING.',
    JOBS_SEARCH_LOCATION_NO_RADIUS: 'Sin radio',
    LEAD_AD_FORM_ACCESSIBILITY_LABEL: 'Formulario de contacto',
    LEBENSLAUF_TEASER_CARD_DESCRIPTION:
      'Multiplica tus oportunidades en un abrir y cerrar de ojos.',
    LEBENSLAUF_TEASER_CARD_TITLE: 'Crea un CV profesional',
    LOADING_ERROR_BODY: 'Vuelve a intentarlo.',
    LOADING_ERROR_CTA: 'Volver a intentar',
    LOADING_ERROR_HEADLINE: 'Lo sentimos, se ha producido un error.',
    LOGGED_OUT_STARTPAGE_META_DESCRIPTION_JOB_SEARCH:
      'Más de 1 millón de ofertas ✓ 20.000 Reclutadores(as) ✓ Estimaciones salariales ✓ Evaluaciones de empleadores. ¡Define tus expectativas laborales y crea tu propio XING!',
    LOGGED_OUT_STARTPAGE_META_TITLE_JOB_SEARCH:
      'Encuentra el trabajo perfecto para ti o consigue que el trabajo venga a ti.',
    LOSP_APPLE_BUTTON: 'Descargar en la App Store',
    LOSP_GOOGLE_BUTTON: 'Descargar en Google Play',
    LOSP_JOBS_SECTION_SUBTITLE: 'Puede que te guste lo siguiente:',
    LOSP_JOBS_SECTION_TITLE: 'Over 1 million jobs to choose from',
    LOSP_KEYWORDS_ACCOUNTANT: '🧮 Accountant',
    LOSP_KEYWORDS_ADMINISTRATION: '🏫 Administración',
    LOSP_KEYWORDS_ANALYST: '📈 Data analyst',
    LOSP_KEYWORDS_BANKER: '💸 Banker',
    LOSP_KEYWORDS_CALLCENTER: '📞 Call centre jobs',
    LOSP_KEYWORDS_CAREERCHANGER: '👣 Career changer',
    LOSP_KEYWORDS_CARETAKER: '👨‍🔧 Facility manager',
    LOSP_KEYWORDS_CONTROLLER: '🎚️ Controller',
    LOSP_KEYWORDS_DESIGN: '🎨 Design jobs',
    LOSP_KEYWORDS_FLIGHTATTENDANT: '🛫 Flight attendant',
    LOSP_KEYWORDS_FORKLIFT: '👷 Forklift driver',
    LOSP_KEYWORDS_FOUNDATION: '🏛️ Fundación',
    LOSP_KEYWORDS_FREELANCE: '👨🏻‍💻 Freelance jobs',
    LOSP_KEYWORDS_HEALTH: '🥕 Health manager',
    LOSP_KEYWORDS_LOGISTICS: '📦 Logistics jobs',
    LOSP_KEYWORDS_MARKETING: '📣 Marketing jobs',
    LOSP_KEYWORDS_MUSEUM: '🖼️ Museum jobs',
    LOSP_KEYWORDS_NURSERY: '👶 Nursery teacher',
    LOSP_KEYWORDS_OFFICECLERK: '👩‍💻 Office clerk',
    LOSP_KEYWORDS_PROJECTMANAGER: '🤹 Project manager',
    LOSP_KEYWORDS_PSYCHOLOGIST: '🛋️ Psychologist',
    LOSP_KEYWORDS_SALES: '💼 Field sales representative',
    LOSP_KEYWORDS_SALES2: '💰 Sales jobs',
    LOSP_KEYWORDS_SECURITY: '👮🏻 Security officer',
    LOSP_KEYWORDS_SOCIALMEDIA: '🤳 Social media manager',
    LOSP_KEYWORDS_SOCIALWORKER: '👨‍👧‍👦 Social worker',
    LOSP_KEYWORDS_SOCIALWORKER2: '❤️‍🔥 Trabajador social',
    LOSP_KEYWORDS_SUSTAINABILITY: '🌿 Sustainability jobs',
    LOSP_KEYWORDS_TRUCK: '🚚 Lorry driver',
    LOSP_KEYWORDS_WORKINGSTUDENT: '🧑🏽‍🎓 Working student',
    LOSP_PREFERENCES_EXPERIMENT_CITIES_BERLIN: 'Berlín',
    LOSP_PREFERENCES_EXPERIMENT_CITIES_BUTTON: 'Ciudades',
    LOSP_PREFERENCES_EXPERIMENT_CITIES_HAMBURG: 'Hamburgo',
    LOSP_PREFERENCES_EXPERIMENT_CITIES_HEADLINE:
      '¿En qué ciudad quieres trabajar?',
    LOSP_PREFERENCES_EXPERIMENT_CITIES_MUNICH: 'Múnich',
    LOSP_PREFERENCES_EXPERIMENT_EMPTY_POPUP_BODY:
      'Cuéntanos tus expectativas profesionales para que podamos recomendarte ofertas interesantes.',
    LOSP_PREFERENCES_EXPERIMENT_EMPTY_POPUP_BUTTON: 'Entendido',
    LOSP_PREFERENCES_EXPERIMENT_EMPTY_POPUP_HEADLINE:
      'Debes seleccionar al menos un criterio.',
    LOSP_PREFERENCES_EXPERIMENT_HEADLINE:
      'Haz que los reclutadores y las reclutadoras vengan a ti',
    LOSP_PREFERENCES_EXPERIMENT_LEVEL_BUTTON: 'Nivel profesional',
    LOSP_PREFERENCES_EXPERIMENT_LEVEL_ENTRY: 'Principiante',
    LOSP_PREFERENCES_EXPERIMENT_LEVEL_HEADLINE:
      '¿Qué nivel profesional debe tener tu siguiente empleo?',
    LOSP_PREFERENCES_EXPERIMENT_LEVEL_MANAGER: 'Mánager',
    LOSP_PREFERENCES_EXPERIMENT_LEVEL_PROFESSIONAL: 'Con experiencia',
    LOSP_PREFERENCES_EXPERIMENT_OTHERS_DISCIPLINES: 'Áreas profesionales',
    LOSP_PREFERENCES_EXPERIMENT_OTHERS_HEADLINE:
      '¿Qué otras preferencias laborales tienes?',
    LOSP_PREFERENCES_EXPERIMENT_OTHERS_INDUSTRIES: 'Sectores',
    LOSP_PREFERENCES_EXPERIMENT_OTHERS_JOBTITLE: 'Puesto',
    LOSP_PREFERENCES_EXPERIMENT_OTHERS_WORKING_HOURS: 'Horario laboral',
    LOSP_PREFERENCES_EXPERIMENT_PLACE_BUTTON: 'Tu lugar de trabajo',
    LOSP_PREFERENCES_EXPERIMENT_PLACE_HEADLINE:
      '¿Cómo quieres trabajar en el futuro?',
    LOSP_PREFERENCES_EXPERIMENT_PLACE_HOMEOFFICE: '100 % desde casa',
    LOSP_PREFERENCES_EXPERIMENT_PLACE_ONSITE: 'En la oficina',
    LOSP_PREFERENCES_EXPERIMENT_SALARY_BUTTON: 'Salario',
    LOSP_PREFERENCES_EXPERIMENT_SALARY_EIGHTY: '80.000 €',
    LOSP_PREFERENCES_EXPERIMENT_SALARY_FORTY: '40.000 €',
    LOSP_PREFERENCES_EXPERIMENT_SALARY_FORTY_FIVE: '45 000 €',
    LOSP_PREFERENCES_EXPERIMENT_SALARY_HEADLINE: '¿Qué salario anual quieres?',
    LOSP_PREFERENCES_EXPERIMENT_SALARY_SIXTY: '60.000 €',
    LOSP_PREFERENCES_EXPERIMENT_SALARY_THIRTY: '30 000 €',
    LOSP_PREFERENCES_EXPERIMENT_SAVE: 'Guardar expectativas profesionales',
    LOSP_PREFERENCES_EXPERIMENT_SAVE_POPUP_BODY:
      'Muchos empleadores interesantes y más de 20.000 reclutadores y reclutadoras buscan a gente como tú en XING. Consigue que las ofertas vengan a ti en forma de recomendaciones de empleo adaptadas a ti. ¡Hazte un perfil en XING!',
    LOSP_PREFERENCES_EXPERIMENT_SAVE_POPUP_BUTTON: 'Inscribirme ahora',
    LOSP_PREFERENCES_EXPERIMENT_SAVE_POPUP_HEADLINE:
      'Haz que las ofertas de empleo lleguen a ti.',
    LOSP_PREFERENCES_EXPERIMENT_SEE_MORE: 'Ver más',
    LOSP_PREFERENCES_EXPERIMENT_SUBHEADLINE:
      'Ahórrate el estrés de buscar empleo, simplemente configura los parámetros más importantes para ti.',
    LOSP_PREFERENCES_EXPERIMENT_WORKPLACE_HOME_OFFICE: '100% desde casa',
    LOSP_PREFERENCES_EXPERIMENT_WORKPLACE_MOSTLY_HOME:
      'Principalmente desde casa',
    LOSP_PREFERENCES_EXPERIMENT_WORKPLACE_OFFICE: 'En la oficina',
    LOSP_PREFERENCES_EXPERIMENT_WORKPLACE_PARTLY_HOME:
      'Parcialmente desde casa',
    LOSP_QR_CODE: 'Código QR para descargar la app',
    LOSP_RECRUITERS_SECTION_COMPANY_CTA: 'Ver ofertas',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_AIRBUS:
      '80% de tasa de recomendación en los últimos dos años',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_AMAZON:
      'Ventajas para empleados: descuentos, aparcamiento, eventos',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_AOK:
      'Más de 1 440 evaluaciones como «Muy bueno»',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_AUDI:
      '86 % está satisfecho con su salario ',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_BAHNE_GROTH:
      'Reclutadores para puestos en la sede de flaschenpost',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_BASF:
      'Ventajas citadas a menudo: horario flexible, teletrabajo, pensión de empleo',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_BMW:
      'Ventajas confirmadas por múltiples personas: comedor, pensión complementaria, descuentos',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_BOSCH:
      'Ventajas confirmadas por múltiples personas: horarios flexibles, médico de empresa',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_CAROLA_LUDEWIG:
      'Reclutadores para personal de seguridad de diferentes niveles',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_DEUTSCHE_BAHN:
      'Tasa de recomendación del 74 % en los últimos 2 años',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_DEUTSCHE_BANK:
      'Ventajas citadas a menudo: horario flexible, pensión de empleo',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_DEUTSCHE_POST:
      'Más de 12.250 evaluaciones de empleados y candidatos',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_DM:
      'Tasa de recomendación del 70 % en los últimos 2 años',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_DUERENHOFF_GMBH:
      'Mejores 10 de kununu: los empleadores más familiares',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_FATMA_KOC:
      'Búsqueda activa para el sector de los servicios financieros',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_FINJA_STRUBER:
      'Reclutadora en la oficina central de ROSSMANN',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_HUSEYIN_YALCIN:
      'Tiempo de respuesta: menos de 3 horas',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_IKEA:
      'Ventajas citadas a menudo: descuentos, comedor, pensión de empleo',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_ISABEL_STRUSCHKA:
      'Persona de contacto para finanzas, TI, sociedad y cultura',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_JAN_GOTZE:
      'Reclutadores en el sector Gestión y expertos en IT',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_JAN_SCHENGBER:
      'Tiempo de respuesta: menos de 4 horas',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_JOHANNA_ECKERT:
      'Reclutador en el área de fiscalidad y auditoría/revisión de cuentas',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_JONAS_MASANNECK:
      'Reclutadores en el sector Non-Tech & Life Sciences',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_JULIA_REICHHOFER:
      'Reclutadora para todos los puestos del Grupo Schmersal',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_KAUFLAND:
      'Más de 2.867 evaluaciones de empleados y candidatos',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_KRISTIN_SEMELKA:
      'Reclutadores en el sector de la formación',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_LIDL: 'kununu Top Company 2023',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_MALTE_BALMER:
      'Tu persona de contacto para tus preguntas sobre las ofertas de empleo de OTTO',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_MARIA_HEUCKE:
      'Pasión por nuestro trabajo #WeEmpowerPeople',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_MEINESTADT_DE:
      '88% de tasa de recomendación en los últimos dos años',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_MIRIAM_DJAMBOU:
      'Consultoría en el sector IT e ingeniería',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_OTTOBOCK:
      'Ventajas citadas a menudo: entrada flexible, médico de empresa',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_PORSCHE:
      '95% está satisfecho con su salario',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_RALPH_OSTERMEIER:
      'Tu contacto para ofertas de empleo de informática en EDEKA ',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_REWE:
      'tasa de recomendación del 61% en los últimos dos años',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_ROBIN_MAURER:
      'Recruiting y branding de empleador para tres empresas',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_ROSSMANN:
      'Más de 1.621 evaluaciones de empleados y candidatos',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_SAP:
      '93% de tasa de recomendación en los últimos dos años',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_SARAH_BAUDZUS:
      'Más de 10 años en el sector de la atención sanitaria y hospitalaria',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_SIEMENS:
      'El 67% confirma los horarios flexibles como beneficio',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_STEFANIE_KLOCK:
      'Consultoría en el sector Especialistas en ventas y marketing',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_VANESSA_STRAUCH:
      'Reclutadora en el sector del transporte y la logística',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_VERONIKA_GERSDORF:
      'Reclutadora para nuestros estudios y oficinas centrales',
    LOSP_RECRUITERS_SECTION_RECRUITER_CTA: 'Ver el perfil',
    LOSP_SEARCH_INSPIRATION_CAREER_LEVEL: 'Tu nivel profesional',
    LOSP_SEARCH_INSPIRATION_DESCRIPTION_CARD_1:
      'Trabaja donde mejor te sientas.',
    LOSP_SEARCH_INSPIRATION_DESCRIPTION_CARD_5:
      'Guarda tiempo libre para otras cosas en la vida.',
    LOSP_SEARCH_INSPIRATION_DESCRIPTION_CARD_6:
      'Por si quieres empezar poco a poco.',
    LOSP_SEARCH_INSPIRATION_PREFERENCES_CAREER_LEVEL_HEADLINE:
      '¿Cuál es tu nivel profesional deseado?',
    LOSP_SEARCH_INSPIRATION_PREFERENCES_DESCRIPTION:
      'Cuéntanos qué es importante para tí, para poder enviarte mejores recomendaciones.',
    LOSP_SEARCH_INSPIRATION_PREFERENCES_DESCRIPTION_2: 'Es fácil y rápido.',
    LOSP_SEARCH_INSPIRATION_PREFERENCES_MODAL_SUBHEADLINE:
      'Cuéntanos qué es importante para tí, para que podamos darte mejores recomendaciones. Es fácil y rápido.',
    LOSP_SEARCH_INSPIRATION_PREFERENCES_MODAL_TITLE:
      'Define tus preferencias de trabajo',
    LOSP_SEARCH_INSPIRATION_PREFERENCES_SALARY_HEADLINE:
      '¿Cuales son tus expectativas salariales?',
    LOSP_SEARCH_INSPIRATION_PREFERENCES_TITLE:
      'Establece tus preferencias de trabajo',
    LOSP_SEARCH_INSPIRATION_PREFERENCES_WORKPLACE_HEADLINE:
      '¿Dónde quieres trabajar en el futuro?',
    LOSP_SEARCH_INSPIRATION_SALARY: 'Tus expectativas salariales',
    LOSP_SEARCH_INSPIRATION_SET_PREFERENCES: 'Guardar preferencias laborales',
    LOSP_SEARCH_INSPIRATION_TITLE_CARD_1: 'Ofertas de trabajo a distancia',
    LOSP_SEARCH_INSPIRATION_TITLE_CARD_3:
      'Ofertas para quienes deseen cambiar el ámbito de su carrera profesional',
    LOSP_SEARCH_INSPIRATION_WORKPLACE: 'Tu lugar de trabajo',
    LOSP_SEO_SECTION_COMPANIES_DIRECTORY: 'Empresas de la A a la Z',
    LOSP_SEO_SECTION_HEADER_DIRECTORIES: 'Directorios',
    LOSP_SEO_SECTION_HEADER_JOB_ROLES: 'Puestos',
    LOSP_SEO_SECTION_HEADER_TOP_LOCATIONS: 'Ciudades clave',
    LOSP_SEO_SECTION_HEADER_TOP_SKILLS: 'Competencias clave',
    LOSP_SEO_SECTION_JOBS_DIRECTORY: 'Ofertas de la A a la Z',
    LOSP_SEO_SECTION_PEOPLE_DIRECTORY: 'Miembros de la A a la Z',
    MORE_OPTIONS_ACCESSIBILITY_LABEL: 'Más opciones',
    NATIVE_ADS_DOT_MENU_REPORT_OBJECT: 'Notificar este anuncio',
    NATIVE_ADS_LEARN_MORE_BUTTON: 'Más información',
    NATIVE_ADS_SPONSORED_LABEL: 'Patrocinado',
    NETWORK_DIRECT_CONNECTIONS_HIRING_HIGHLIGHTS_CTA: 'Ver detalles',
    NETWORK_MY_NETWORK_BOOST_ME_UP_BANNER_CTA: 'Jetzt Profil boosten',
    NETWORK_MY_NETWORK_BOOST_ME_UP_BANNER_HEADLINE_1: 'Schneller zum',
    NETWORK_MY_NETWORK_BOOST_ME_UP_BANNER_HEADLINE_2: 'nächsten Job',
    NETWORK_MY_NETWORK_BOOST_ME_UP_BANNER_PRE_HEADLINE: 'Kostenlos für Dich',
    NETWORK_MY_NETWORK_BOOST_ME_UP_BANNER_SUBLINE:
      'Heb Dein Profil 14 Tage lang für Recruiter·innen hervor und sicher Dir die Chance auf mehr Job-Angebote.',
    NETWORK_MY_NETWORK_PROFILE_COMPLETION_CARD_CTA_100: 'Actualiza el perfil',
    NETWORK_MY_NETWORK_PROFILE_COMPLETION_CARD_DESCRIPTION_100:
      'Revisar tu perfil regularmente para asegurarte de que está actualizado',
    NETWORK_MY_NETWORK_ROMP_BASIC_BANNER_GET_PROJOBS_CTA: 'Adquirir ProJobs',
    NETWORK_MY_NETWORK_ROMP_BASIC_NO_VISITORS_BANNER_BODY:
      'Con ProJobs, multiplicas tu visibilidad y ayudas a que te encuentren más rápidamente.',
    NETWORK_MY_NETWORK_ROMP_BASIC_NO_VISITORS_BANNER_HEADLINE:
      '¿Qué profesionales de la contratación están interesados en tu perfil?',
    NETWORK_MY_NETWORK_ROMP_BASIC_WITH_VISITORS_BANNER_BODY:
      'Estos profesionales de los RR. HH. han consultado tu perfil. Averigua quiénes son con la cuenta ProJobs.',
    NETWORK_MY_NETWORK_ROMP_BASIC_WITH_VISITORS_BANNER_HEADLINE:
      '¿Quién se interesa por tu perfil?',
    NETWORK_MY_NETWORK_ROMP_BASIC_WITH_VISITORS_BANNER_VIEW_ALL_VISITS_CTA:
      'Ver todas las visitas',
    NETWORK_MY_NETWORK_ROMP_BASIC_WITH_VISITORS_VISITOR_FENCED_NAME:
      'Reclutadores(as)',
    NETWORK_MY_NETWORK_ROMP_EMPTY_STATE_BODY:
      'Cuanto más grande sea tu red, mayor será tu visibilidad. Y, además, así aumentas las visitas a tu perfil.',
    NETWORK_MY_NETWORK_ROMP_EMPTY_STATE_CTA:
      'Descubrir profesionales de HH. RR.',
    NETWORK_MY_NETWORK_ROMP_EMPTY_STATE_HEADLINE:
      '¿Ningún reclutador o reclutadora ha visitado tu perfil aún?',
    NETWORK_MY_NETWORK_ROMP_PREMIUM_REASSURANCE_BODY:
      'Con la cuenta Premium ves qué profesionales de los RR. HH. han visitado tu perfil.',
    NETWORK_MY_NETWORK_ROMP_PREMIUM_REASSURANCE_CTA:
      'Ver todas las ventajas Premium',
    NETWORK_MY_NETWORK_ROMP_PREMIUM_REASSURANCE_HEADLINE:
      'Averigua qué profesionales de los RR. HH. se han interesado por ti.',
    NETWORK_MY_NETWORK_ROMP_PROJOBS_REASSURANCE_BODY:
      'ProJobs te permite ver qué profesionales de RR. HH. han consultado tu perfil.',
    NETWORK_MY_NETWORK_ROMP_PROJOBS_REASSURANCE_CTA:
      'Ver todas las ventajas ProJobs',
    NETWORK_MY_NETWORK_ROMP_PROJOBS_REASSURANCE_HEADLINE:
      'Averigua qué profesionales de los RR. HH. se han interesado por ti.',
    NETWORK_MY_NETWORK_ROMP_VISITORS_ACCEPT_CONTACT_REQUEST: 'Aceptar',
    NETWORK_MY_NETWORK_ROMP_VISITORS_ADD_SEND_CONTACT_REQUEST:
      'Añadir a contactos',
    NETWORK_MY_NETWORK_ROMP_VISITORS_DECLINE_CONTACT_REQUEST: 'Rechazar',
    NETWORK_MY_NETWORK_ROMP_VISITORS_EXTERNAL_RECRUITER: 'Visita externa',
    NETWORK_MY_NETWORK_ROMP_VISITORS_HEADLINE:
      'Profesionales de RR. HH. que se han interesado por tu perfil',
    NETWORK_MY_NETWORK_ROMP_VISITORS_SHOW_MORE_BUTTON: 'Ver más',
    NETWORK_MY_NETWORK_ROMP_VISITORS_TIME_FRAME: 'En los últimos 90 días',
    NETWORK_MY_NETWORK_ROMP_VISITORS_WRITE_MESSAGE: 'Escribir mensaje',
    NETWORK_MY_NETWORK_VISIBILITY_BANNER_CTA: 'Optimizar perfil',
    NETWORK_MY_NETWORK_VISIBILITY_BANNER_DESCRIPTION:
      'Un perfil relleno en su totalidad aumenta las posibilidades de que los reclutadores te encuentren.',
    NETWORK_MY_NETWORK_VISIBILITY_BANNER_TITLE:
      'Tasa de finalización del perfil',
    NETWORK_MYMK_ABOUT_ME_TITLE: 'Sobre mí',
    NETWORK_MYMK_SHOW_MORE_BUTTON: 'Ver más',
    NETWORK_MYMK_TOTAL_SHARED_CONTACTS_WEB: 'Contactos en común',
    NETWORK_MYNETWORK_BIRTHDAY_EMPTY: 'No hay cumpleaños a la vista.',
    NETWORK_MYNETWORK_BIRTHDAY_HAS_BIRTHDAY: 'cumple años.',
    NETWORK_MYNETWORK_BIRTHDAY_HEADLINE: 'Cumpleaños',
    NETWORK_MYNETWORK_BIRTHDAY_MULTIPLE_CONTACTS_HAVE:
      '{count} de tus contactos cumplen',
    NETWORK_MYNETWORK_BIRTHDAY_ONE_CONTACT_HAS: 'Uno de tus contactos cumple',
    NETWORK_MYNETWORK_BIRTHDAY_TODAY: 'años hoy.',
    NETWORK_MYNETWORK_BIRTHDAY_TODAY_BECOMES_AGE: 'cumple hoy {age} años.',
    NETWORK_MYNETWORK_BIRTHDAY_TWO_CONTACTS_HAVE: '{name1} y {name2} ',
    NETWORK_MYNETWORK_BIRTHDAY_WILL_BECOME_AGE: 'cumple {age} el {date}.',
    NETWORK_MYNETWORK_BIRTHDAY_WILL_BECOME_AGE_NO_DATE: 'cumple {age} años.',
    NETWORK_MYNETWORK_BIRTHDAY_WILL_HAVE_BIRTHDAY: 'cumple años el {date}.',
    NETWORK_MYNETWORK_BIRTHDAY_WILL_HAVE_BIRTHDAY_NO_DATE: 'cumple años.',
    NETWORK_MYNETWORK_CONTACT_HEADLINE: 'Contactos',
    NETWORK_MYNETWORK_CONTACT_MULTIPLE: 'Tienes <b>{count} contactos</b>.',
    NETWORK_MYNETWORK_CONTACT_REQUEST_COMMON_CONTACTS:
      '{amount} contactos en común',
    NETWORK_MYNETWORK_CONTACT_REQUEST_EMPTY_HEADLINE:
      'No tienes solicitudes de contacto pendientes',
    NETWORK_MYNETWORK_CONTACT_REQUEST_HEADLINE: 'Solicitudes de contacto',
    NETWORK_MYNETWORK_CONTACT_REQUEST_MULTIPLE_HEADLINE:
      'Tienes <b>{count} solicitudes de contacto pendientes</b>\n',
    NETWORK_MYNETWORK_CONTACT_REQUEST_SINGLE_HEADLINE:
      'Tienes <b>una nueva solicitud de contacto:</b>',
    NETWORK_MYNETWORK_CONTACT_REQUEST_TWO_REQUESTS: 'de {name1} y {name2}.',
    NETWORK_MYNETWORK_CONTACT_REQUEST_VIEW_ALL:
      'Ver todas las solicitudes de contacto',
    NETWORK_MYNETWORK_CONTACT_REQUESTS_EMPTY_STATE_CTA1:
      'Descubre a gente apasionante',
    NETWORK_MYNETWORK_CONTACT_REQUESTS_EMPTY_STATE_CTA2:
      'Ver todas las solicitudes',
    NETWORK_MYNETWORK_CONTACT_REQUESTS_EMPTY_STATE_DESCRIPTION:
      'Haz contactos nuevos y aprovecha el poder de la red.',
    NETWORK_MYNETWORK_CONTACT_REQUESTS_EMPTY_STATE_SUBLINE:
      'Por ahora no hay nada que hacer aquí.',
    NETWORK_MYNETWORK_CONTACT_REQUESTS_EMPTY_STATE_TITLE:
      'Solicitudes de contacto',
    NETWORK_MYNETWORK_CONTACT_SEARCH_PLACEHOLDER: 'Buscar en mis contactos',
    NETWORK_MYNETWORK_CONTACT_SINGLE: 'Tienes <b>{count} contacto</b>.',
    NETWORK_MYNETWORK_DEFAULT_ERROR_MESSAGE:
      'Parece que se ha producido un error. Por favor, vuelve a intentarlo.',
    NETWORK_MYNETWORK_EMPTY_STATE_DESCRIPTION:
      'Haz contactos nuevos y aprovecha el poder de la red.',
    NETWORK_MYNETWORK_EMPTY_STATE_HEADLINE:
      'Por ahora no hay nada que hacer aquí.',
    NETWORK_MYNETWORK_HEADLINE: 'Tu red',
    NETWORK_MYNETWORK_HEADLINE_WEB: 'Red',
    NETWORK_MYNETWORK_HIRING_HIGHLIGHTS_BANNER_CONFIRMATION_CTA: 'Ver detalles',
    NETWORK_MYNETWORK_HIRING_HIGHLIGHTS_BANNER_CONFIRMATION_TEXT:
      '¡Listo! Hemos actualizado tu sección de contratación.',
    NETWORK_MYNETWORK_HIRING_HIGHLIGHTS_BANNER_NO_CTA: 'Ahora no',
    NETWORK_MYNETWORK_HIRING_HIGHLIGHTS_BANNER_SUBLINE:
      'Cuenta en XING qué perfil buscas e incorpora a los mejores talentos.',
    NETWORK_MYNETWORK_HIRING_HIGHLIGHTS_BANNER_TITLE:
      'Hola, {firstname}. ¿Buscas nuevos talentos?',
    NETWORK_MYNETWORK_HIRING_HIGHLIGHTS_BANNER_YES_CTA: 'Sí, busco',
    NETWORK_MYNETWORK_MEMBER_SEARCH_HEADLINE: 'Buscar usuarios',
    NETWORK_MYNETWORK_MEMBER_SEARCH_PLACEHOLDER: 'Introducir nombre o empresa',
    NETWORK_MYNETWORK_MYMK_HEADLINE: 'Miembros',
    NETWORK_MYNETWORK_NUM_CONTACTS:
      '{count, number} {count, plural,\n  one {contacto.}\n  other {contactos.}\n}',
    NETWORK_MYNETWORK_PROFILE_VISITORS_CTA_BASIC: 'Pásate a Premium',
    NETWORK_MYNETWORK_PROFILE_VISITORS_CTA_PREMIUM: 'Ver las visitas al perfil',
    NETWORK_MYNETWORK_PROFILE_VISITORS_DESCRIPTION_BASIC:
      'Pásate a la cuenta <b>Premium</b> para poner cara a quienes visitan tu perfil.',
    NETWORK_MYNETWORK_PROFILE_VISITORS_DESCRIPTION_PREMIUM:
      'Conecta con las visitas a tu perfil y realiza búsquedas sobre las empresas para las que trabajan.',
    NETWORK_MYNETWORK_PROFILE_VISITORS_ENTRYPOINT_CTA: 'Ver todo',
    NETWORK_MYNETWORK_PROFILE_VISITORS_ENTRYPOINT_HEADLINE:
      '¿Quieres saber quién se interesa por tu perfil?',
    NETWORK_MYNETWORK_PROFILE_VISITORS_HEADLINE: 'Visitas a tu perfil',
    NETWORK_MYNETWORK_PROFILE_VISITORS_NUMBER_OF_VISITS: 'visitas',
    NETWORK_MYNETWORK_RECOMMENDATIONS_COMPANIES: 'Sois compañeros de trabajo.',
    NETWORK_MYNETWORK_RECOMMENDATIONS_COMPANIES_CONTACTS_MANY:
      'Sois compañeros de trabajo y tenéis {count} contactos en común.',
    NETWORK_MYNETWORK_RECOMMENDATIONS_COMPANIES_CONTACTS_ONE:
      'Trabajáis en el mismo sitio y tenéis un contacto en común.',
    NETWORK_MYNETWORK_RECOMMENDATIONS_COMPANIES_CONTACTS_PRIVATE:
      'Sois compañeros de trabajo y tenéis contactos en común.',
    NETWORK_MYNETWORK_RECOMMENDATIONS_COMPANIES_EVENTS:
      'Sois compañeros de trabajo que habéis asistido a los mismos eventos.',
    NETWORK_MYNETWORK_RECOMMENDATIONS_COMPANIES_GROUPS:
      'Sois compañeros de trabajo y miembros de los mismos grupos.',
    NETWORK_MYNETWORK_RECOMMENDATIONS_COMPANIES_PAST:
      'Erais compañeros de trabajo.',
    NETWORK_MYNETWORK_RECOMMENDATIONS_COMPANIES_PAST_CONTACTS_MANY:
      'Habéis trabajado en la misma empresa y tenéis {count} contactos en común.',
    NETWORK_MYNETWORK_RECOMMENDATIONS_COMPANIES_PAST_CONTACTS_ONE:
      'Habéis trabajado en la misma empresa y tenéis un contacto en común.',
    NETWORK_MYNETWORK_RECOMMENDATIONS_COMPANIES_PAST_CONTACTS_PRIVATE:
      'Habéis trabajado en la misma empresa y tenéis contactos en común.',
    NETWORK_MYNETWORK_RECOMMENDATIONS_COMPANIES_PAST_EVENTS:
      'Sois ex-compañeros que habéis asistido a los mismos eventos.',
    NETWORK_MYNETWORK_RECOMMENDATIONS_COMPANIES_PAST_GROUPS:
      'Sois antiguos compañeros y miembros de los mismos grupos.',
    NETWORK_MYNETWORK_RECOMMENDATIONS_CONTACTS_GROUPS_MANY:
      'Tenéis {count} contactos en común y pertenecéis al mismo grupo.',
    NETWORK_MYNETWORK_RECOMMENDATIONS_CONTACTS_GROUPS_ONE:
      'Tenéis un contacto en común y sois miembros de los mismos grupos.',
    NETWORK_MYNETWORK_RECOMMENDATIONS_CONTACTS_GROUPS_PRIVATE:
      'Tenéis contactos en común y sois miembros del mismo grupo.',
    NETWORK_MYNETWORK_RECOMMENDATIONS_CONTACTS_MANY:
      'Tenéis {count} contactos en común.',
    NETWORK_MYNETWORK_RECOMMENDATIONS_CONTACTS_ONE:
      'Tenéis un contacto en común.',
    NETWORK_MYNETWORK_RECOMMENDATIONS_CONTACTS_PRIVATE:
      'Tenéis contactos en común.',
    NETWORK_MYNETWORK_RECOMMENDATIONS_CTA: 'Añadir',
    NETWORK_MYNETWORK_RECOMMENDATIONS_EMAIL_CONTACT:
      'Uno de tus contactos de correo electrónico',
    NETWORK_MYNETWORK_RECOMMENDATIONS_EVENTS:
      'Habéis asistido a los mismos eventos.',
    NETWORK_MYNETWORK_RECOMMENDATIONS_EVENTS_CONTACTS_MANY:
      'Habéis asistido a los mismos eventos y tenéis {count} contactos en común.',
    NETWORK_MYNETWORK_RECOMMENDATIONS_EVENTS_CONTACTS_ONE:
      'Habéis asistido a los mismos eventos y tenéis un contacto en común.',
    NETWORK_MYNETWORK_RECOMMENDATIONS_EVENTS_CONTACTS_PRIVATE:
      'Tenéis contactos en común y habéis asistido a los mismos eventos.',
    NETWORK_MYNETWORK_RECOMMENDATIONS_EVENTS_GROUPS:
      'Sois miembros de los mismos grupos y habéis asistido a los mismos eventos.',
    NETWORK_MYNETWORK_RECOMMENDATIONS_GROUPS:
      'Sois miembros de los mismos grupos.',
    NETWORK_MYNETWORK_RECOMMENDATIONS_HEADLINE:
      'Amplía tu red personal de ofertas de empleo',
    NETWORK_MYNETWORK_RECOMMENDATIONS_SEND_MESSAGE: 'Enviar mensaje',
    NETWORK_MYNETWORK_RECOMMENDATIONS_SUBLINE:
      '¿Conoces a alguien? Amplía ahora tu red de contactos.',
    NETWORK_MYNETWORK_RECRUITER_INTERACTIONS_CTA_BASIC: 'Pásate a ProJobs',
    NETWORK_MYNETWORK_RECRUITER_INTERACTIONS_CTA_PROJOBS:
      'Ver las interacciones',
    NETWORK_MYNETWORK_RECRUITER_INTERACTIONS_DESCRIPTION_BASIC:
      'Descubre quién ha encontrado y guardado tu perfil, desbloquea todas las ventajas Premium, y mucho más con <b>ProJobs</b>.',
    NETWORK_MYNETWORK_RECRUITER_INTERACTIONS_DESCRIPTION_PROJOBS:
      'Mira qué reclutadores han encontrado y guardado tu perfil.',
    NETWORK_MYNETWORK_RECRUITER_INTERACTIONS_HEADLINE:
      'Interacciones con los reclutadores',
    NETWORK_MYNETWORK_RECRUITER_INTERACTIONS_NUMBER_OF_BOOKMARKS: 'guardadas',
    NETWORK_MYNETWORK_RECRUITER_INTERACTIONS_NUMBER_OF_SEARCHES:
      'resultados de la búsqueda',
    NETWORK_MYNETWORK_RECRUITER_INTERACTIONS_TOTAL: 'Interacciones',
    NETWORK_MYNETWORK_RECRUITERS_CTA: 'Ver el perfil',
    NETWORK_MYNETWORK_RECRUITERS_DESCRIPTION:
      'Echa un vistazo a su perfil y sopesa si quieres dejar un mensaje. Incluso si no hay nada adecuado en este momento.',
    NETWORK_MYNETWORK_RECRUITERS_HEADLINE:
      'Reclutadores que a menudo buscan datos como los tuyos.',
    NETWORK_MYNETWORK_RECRUITERS_HIRING_DISCIPLINE:
      'Suele buscar para tu especialidad.',
    NETWORK_MYNETWORK_RECRUITERS_HIRING_INDUSTRY: 'Suele buscar en tu sector.',
    NETWORK_MYNETWORK_RECRUITERS_HIRING_JOB_ROLE:
      'Suele buscar para tu puesto.',
    NETWORK_MYNETWORK_RECRUITERS_MARKER_HIRING: 'Busca personal',
    NETWORK_MYNETWORK_RECRUITERS_RECOMMENDATIONS_SEE_MORE_CTA: 'Ver perfiles',
    NETWORK_MYNETWORK_RECRUITERS_RECOMMENDATIONS_SEE_MORE_TEXT:
      'Aún queda mucho por descubrir.',
    NETWORK_MYNETWORK_TIPBOX_CTA: 'Siguiente',
    NETWORK_MYNETWORK_TIPBOX_CTA_FINAL: 'Entendido',
    NETWORK_MYNETWORK_TIPBOX_MARKER: 'Nuevo',
    NETWORK_MYNETWORK_TIPBOX_PROFILE_VISITORS_DESCRIPTION:
      'Descubre quién, cuándo y por qué ha consultado tu perfil.',
    NETWORK_MYNETWORK_TIPBOX_PROFILE_VISITORS_TITLE: 'Visitas a tu perfil',
    NETWORK_MYNETWORK_TIPBOX_PROFILE_VISITS_DESCRIPTION:
      'Aquí puedes acceder a una vista general de todos los visitantes de tu perfil.',
    NETWORK_MYNETWORK_TIPBOX_PROFILE_VISITS_TITLE: 'Visitas a tu perfil',
    NETWORK_MYNETWORK_TIPBOX_RECRUITER_INTERACTIONS_DESCRIPTION:
      'Mira qué reclutadores han encontrado y guardado tu perfil.',
    NETWORK_MYNETWORK_TIPBOX_RECRUITER_INTERACTIONS_TITLE:
      'Interacciones con los reclutadores',
    NETWORK_MYNETWORK_TIPBOX_SEARCH_MEMBERS_DESCRIPTION:
      'introduce un nombre o una empresa para buscarlos en XING.',
    NETWORK_MYNETWORK_TIPBOX_SEARCH_MEMBERS_TITLE: 'Buscar usuarios',
    NETWORK_RECOMMENDATION_CATEGORY_ALL: 'Todo',
    NETWORK_RECOMMENDATION_CATEGORY_COWORKER_CURRENT: 'Compañeros',
    NETWORK_RECOMMENDATION_CATEGORY_COWORKER_PREVIOUS: 'Antiguos compañeros',
    NETWORK_RECOMMENDATION_CATEGORY_NEW_CONNECTIONS:
      'Nuevos contactos de tus contactos',
    NETWORK_RECOMMENDATION_CATEGORY_RECOMMENDATIONS: 'Recomendaciones',
    NETWORK_RECOMMENDATION_CATEGORY_SHARE_CONTACTS: 'Contactos en común',
    NETWORK_RECOMMENDATION_CATEGORY_SIMILAR_CAREER_PATH: 'Perfiles similares',
    NETWORK_RECOMMENDATIONS_ACCEPTED_START_CONVERSATION:
      '¿Quieres saludar ahora?',
    NETWORK_RECOMMENDATIONS_ACCEPTED_SUCCESS: 'Estás conectado a {userName}.',
    NETWORK_RECOMMENDATIONS_EMPTY_STATE_TIP_1:
      'Tu trayectoria (experiencia profesional y formación)',
    NETWORK_RECOMMENDATIONS_EMPTY_STATE_TIP_2:
      'Organizaciones (p. ej., asociaciones) a las que estás suscrito',
    NETWORK_RECOMMENDATIONS_EMPTY_STATE_TIPS_COPY:
      ' ¡Listo! Esta información nos permite sugerirte posibles contactos.',
    NETWORK_RECOMMENDATIONS_EMPTY_STATE_TIPS_CTA: 'Completa el perfil',
    NETWORK_RECOMMENDATIONS_EMPTY_STATE_TIPS_HEADLINE:
      '¿Quieres recibir recomendaciones de contacto de XING? Completa los siguientes apartados en tu perfil de XING:',
    NETWORK_RECOMMENDATIONS_SEND_MESSAGE:
      'Organizaciones (p. ej., asociaciones) a las que estás suscrito',
    NETWORK_RECOMMENDATIONS_SENT_HEADLINE:
      'Se ha enviado tu solicitud de contacto para {userName}. ',
    NETWORK_RECOMMENDATIONS_SENT_SENT_MESSAGE_BASIC: 'Sigue generando redes.',
    NETWORK_RECOMMENDATIONS_SENT_SENT_MESSAGE_PREMIUM:
      'Aprovecha para saludar.',
    NETWORK_REQUEST_ERROR_DIALOG_CONTACT_LIMIT_REACHED_CTA:
      'Ir a solicitudes enviadas',
    NETWORK_REQUEST_ERROR_DIALOG_CONTACT_LIMIT_REACHED_HEADLINE:
      'Alerta de sociabilidad',
    NETWORK_REQUEST_ERROR_DIALOG_CONTACT_LIMIT_REACHED_TEXT:
      'Antes de enviar más solicitudes de contacto deberías revisar los anteriores y borrarlas si es necesario.',
    NETWORK_REQUESTS_BUTTON_ACCEPT: 'Aceptar',
    NETWORK_REQUESTS_BUTTON_REPORT_SPAM: 'Denunciar correo basura',
    NETWORK_REQUESTS_BUTTON_SEND_MESSAGE: 'Enviar un mensaje',
    NETWORK_REQUESTS_DIALOG_CANCEL: 'Cancelar',
    NETWORK_REQUESTS_DIALOG_DECLINE_HEADLINE:
      '¿Quieres eliminar la solicitud de contacto?',
    NETWORK_REQUESTS_DIALOG_DECLINE_TEXT:
      'No se notificará al usuario sobre esto.',
    NETWORK_REQUESTS_DIALOG_DENY: 'Eliminar la solicitud',
    NETWORK_REQUESTS_DIALOG_SEND: 'Enviar',
    NETWORK_REQUESTS_EMPTY_STATE_CTA: 'Descubre nuevos contactos',
    NETWORK_REQUESTS_HEADLINE: 'Solicitudes de contacto',
    NETWORK_REQUESTS_MODAL_OPEN_ARIA_LABEL: 'solicitudes abiertas recibidas',
    NETWORK_REQUESTS_RECEIVED_SPAM_HEADER:
      'Notificar como correo no deseado o abuso',
    NETWORK_REQUESTS_RECEIVED_SPAM_TEXT:
      'Cuéntanos por qué notificas este contenido como correo no deseado para poder procesar tu solicitud más rápidamente. ¡Muchas gracias!',
    NETWORK_REQUESTS_TABNAV_RECEIVED: 'Solicitudes recibidas',
    NETWORK_SEARCH_AND_SWIPE_ABOUT_BUTTON_LABEL: 'Entendido',
    NETWORK_SEARCH_AND_SWIPE_BOTTOM_SHEET_ABOUT_THIS_FEATURE:
      'Más información sobre esta función',
    NETWORK_SEARCH_AND_SWIPE_BOTTOM_SHEET_RESTART_TUTORIAL:
      'Volver a ver los consejos',
    NETWORK_SEARCH_AND_SWIPE_CONTACT_REQUEST_LIMIT_DESCRIPTION_WEB:
      'Puedes enviar un máximo de 100 solicitudes de contacto; este límite ya se ha alcanzado. Si deseas enviar más solicitudes, debes retirar las solicitudes pendientes.\n{br}<a>Ver todas las solicitudes de contacto > Solicitudes enviadas</a>',
    NETWORK_SEARCH_AND_SWIPE_CONTACT_REQUEST_LIMIT_TITLE:
      'Revisa tus solicitudes de contacto enviadas',
    NETWORK_SEARCH_AND_SWIPE_CONTACT_REQUEST_LIMIT_WARNING_BUTTON: 'Entendido',
    NETWORK_SEARCH_AND_SWIPE_CONTACT_REQUEST_LIMIT_WARNING_MESSAGE:
      'Pronto alcanzarás el límite máximo de solicitudes de contacto.',
    NETWORK_SEARCH_AND_SWIPE_CONTACT_REQUEST_LIMIT_WARNING_TITLE: '¡Atención!',
    NETWORK_SEARCH_AND_SWIPE_DISCARD_RECOMMENDATION_BUTTON_A11Y:
      'Omitir recomendación de contacto',
    NETWORK_SEARCH_AND_SWIPE_MYMK_EMPTY_CARD_DESCRIPTION:
      'Solo queremos sugerirte personas que realmente tengan algo que aportar. Por eso, completa la información de tu perfil para que podamos entender mejor quién podría ser interesante para tu red.',
    NETWORK_SEARCH_AND_SWIPE_MYMK_EMPTY_CARD_TITLE:
      'No hay sugerencias de contacto adecuadas',
    NETWORK_SEARCH_AND_SWIPE_MYMK_NO_MORE_RECOMMENDATIONS_DESCRIPTION:
      'Para obtener más y mejores sugerencias de contactos, solo tienes que completar la información de tu perfil. Así podremos entender mejor quién podría ser interesante para tu red.',
    NETWORK_SEARCH_AND_SWIPE_MYMK_NO_MORE_RECOMMENDATIONS_TITLE:
      'Eso es todo por ahora.',
    NETWORK_SEARCH_AND_SWIPE_PRIVACY_CONTACT_REQUEST_FAILURE_MESSAGE:
      'No se ha podido enviar tu solicitud de contacto.',
    NETWORK_SEARCH_AND_SWIPE_PRIVACY_CONTACT_REQUEST_SUCESS_MESSAGE:
      'Se ha enviado tu solicitud de contacto.',
    NETWORK_SEARCH_AND_SWIPE_PRIVACY_POLICY_DESCRIPTION_WEB:
      'Si deslizas hacia la izquierda o hacia la derecha, los demás miembros podrán ver que has visto su perfil o partes del mismo. Encontrarás más información sobre el tema "ruta de clics" en la <a>política de protección de datos</a>.',
    NETWORK_SEARCH_AND_SWIPE_PRIVACY_POLICY_LINK:
      'https://privacy.xing.com/en/privacy-policy/information-we-automatically-receive-through-your-use-of-xing/provision-of-our-service/examples',
    NETWORK_SEARCH_AND_SWIPE_PRIVACY_POLICY_TITLE:
      'Información sobre esta función',
    NETWORK_SEARCH_AND_SWIPE_SEND_CONTACT_REQUEST_BUTTON_A11Y:
      'Enviar solicitud de contacto',
    NETWORK_SEARCH_AND_SWIPE_TUTORIAL_CONTACT_REQUESTS_HINT_DESCRIPTION_WEB:
      'Para comprobar tus <a>solicitudes de contacto</a> enviadas y recibidas y ver más información sobre tu red.',
    NETWORK_SEARCH_AND_SWIPE_TUTORIAL_CONTACT_REQUESTS_HINT_TITLE:
      'Desplázate hacia abajo',
    NETWORK_SEARCH_AND_SWIPE_TUTORIAL_INTO_DESCRIPTION:
      'Hemos renovado tus recomendaciones de contacto: tu networking ahora es aún más fácil.',
    NETWORK_SEARCH_AND_SWIPE_TUTORIAL_INTO_TITLE_WEB: 'Hola {username}:',
    NETWORK_SEARCH_AND_SWIPE_TUTORIAL_LEGAL_NOTE_DESCRIPTION_WEB:
      'Otros miembros pueden ver que has visto su perfil o partes del mismo. Encontrarás más información sobre el tema "ruta de clics" en la <a>política de protección de datos</a>.',
    NETWORK_SEARCH_AND_SWIPE_TUTORIAL_LEGAL_NOTE_TITLE: 'Por cierto:',
    NETWORK_SEARCH_AND_SWIPE_TUTORIAL_SWIPE_LEFT_DESCRIPTION_WEB:
      'Si no quieres enviar <b>ninguna solicitud de contacto</b>.',
    NETWORK_SEARCH_AND_SWIPE_TUTORIAL_SWIPE_LEFT_TITLE:
      'Desliza hacia la izquierda',
    NETWORK_SEARCH_AND_SWIPE_TUTORIAL_SWIPE_RIGHT_DESCRIPTION_WEB:
      'Y envía directamente <b>una solicitud de contacto</b>.',
    NETWORK_SEARCH_AND_SWIPE_TUTORIAL_SWIPE_RIGHT_TITLE:
      'Desliza hacia la derecha',
    PROFILE_TEASER_CARD_DESCRIPTION:
      'Es gratis y multiplica tus oportunidades en tu búsqueda de empleo.',
    PROFILE_TEASER_CARD_TITLE: 'Crea un perfil de XING',
    QR_CODE_BANNER_SUBTITLE:
      'Porque tu próximo trabajo se encuentra a un XING.',
    QR_CODE_BANNER_TITLE: 'Descargar la aplicación de XING',
    REASSURANCE_ARIA_LABEL: 'Acreditación {variant}',
    RECRUITERS_SECTION_FIRST_SUBTITLE:
      'Crea un perfil de XING y consigue que las ofertas vengan a ti',
    RECRUITERS_SECTION_FIRST_TITLE: 'Haz que las ofertas vengan a ti.',
    RECRUITERS_SECTION_FLAG_COMPANIES: 'Ofertas disponibles',
    RECRUITERS_SECTION_FLAG_RECRUITERS: 'Ofertas disponibles',
    RECRUITERS_SECTION_REGISTER_BUTTON: 'Crear un perfil',
    RECRUITERS_SECTION_REGISTER_WITH_GOOGLE_BUTTON: 'Seguir con Google',
    RECRUITERS_SECTION_SECOND_SUBTITLE:
      'Entra en contacto con más de 20 000 reclutadores y reclutadoras',
    RECRUITERS_SECTION_SECOND_TITLE: 'Conecta con éxito',
    REGISTER_SECTION_DATE_MARK: 'Hoy',
    REGISTER_SECTION_FIRST_TAG: 'Tus expectativas salariales',
    REGISTER_SECTION_HEADLINE: '4 solicitudes nuevas',
    REGISTER_SECTION_SECOND_TAG: 'Tu sector',
    REGISTER_SECTION_THIRD_TAG: 'Tu nivel profesional preferido',
    SEARCH_AND_SWIPE_SEARCH_WITH_AI: 'Encuentra tu próximo empleo con IA',
    SEO_SECTION_TITLE: 'Sugerencias de búsqueda',
    TITLE_CARD_1: 'Ofertas con teletrabajo',
    TITLE_CARD_2: 'Trabajos con horarios flexibles',
    TITLE_CARD_3: 'Empleo en diferentes campos',
    TITLE_CARD_4: 'Ofertas con los mayores salarios',
    TITLE_CARD_5: 'Puestos a jornada parcial',
    TITLE_CARD_6: 'Minijobs',
    WELCOME_APP_MINIREG_ERROR_EMAIL:
      'Comprueba tu dirección de correo electrónico.',
    WELCOME_APP_MINIREG_ERROR_FIRST_NAME: 'Introduce aquí tu nombre.',
    WELCOME_APP_MINIREG_ERROR_LAST_NAME: 'Introduce aquí tu(s) apellido(s).',
    WELCOME_APP_MINIREG_ERROR_PASSWORD_EMAIL:
      'Por razones de seguridad, es recomendable que no utilices la misma contraseña que para tu correo electrónico.',
    WELCOME_APP_MINIREG_ERROR_PASSWORD_LAST_NAME:
      'Por razones de seguridad, es recomendable que tu contraseña no coincida con tu apellido.',
    WELCOME_APP_MINIREG_ERROR_PASSWORD_TOO_LONG:
      'Selecciona una contraseña que no supere los 1024 caracteres.',
    WELCOME_APP_MINIREG_ERROR_PHONE: 'Comprueba tu número de teléfono.',
    WELCOME_APP_MINIREG_ERROR_TANDC:
      'Debes confirmar que aceptas las Condiciones Generales y la normativa de Protección de Datos',
    WELCOME_COMPLETION_HEADLINE: '¡Bienvenid@ a XING!',
    WELCOME_COMPLETION_PAGE_META_TITLE: '¡Bienvenid@ a XING! | XING',
    WELCOME_COMPLETION_SUBLINE:
      'Solo faltan unos datos para completar tu inscripción:',
    WELCOME_COMPLETION_SUBLINE_B:
      'Solo faltan unos datos para completar tu inscripción:',
    WELCOME_COMPLETION_SUBLINE_C:
      'Solo faltan unos datos para completar tu inscripción:',
    WELCOME_COMPLETION_SUBLINE_D:
      'Solo faltan unos datos para completar tu inscripción:',
    WELCOME_COMPLETION_SUBLINE_E:
      'Solo faltan unos datos para completar tu inscripción:',
    WELCOME_CONFIRMATION_DEFAULT_BOUNCED_BODY:
      'Por favor, vuelve a comprobar que la dirección de correo electrónico es correcta. Si lo es, {link}.',
    WELCOME_CONFIRMATION_DEFAULT_BOUNCED_CTA:
      'Corregir la dirección de correo electrónico',
    WELCOME_CONFIRMATION_DEFAULT_BOUNCED_HEADER:
      'No ha sido posible entregar tu mensaje de correo electrónico',
    WELCOME_CONFIRMATION_DEFAULT_BOUNCED_SUPPORT_LINK_TEXT:
      'Ponte en contacto con nosotros',
    WELCOME_CONFIRMATION_DEFAULT_BUTTON:
      '¿No has recibido el correo electrónico?',
    WELCOME_CONFIRMATION_DEFAULT_COPY_1: 'Activa ahora tu cuenta de acceso:',
    WELCOME_CONFIRMATION_DEFAULT_COPY_1_C:
      'Te hemos enviado un enlace a {email}.*',
    WELCOME_CONFIRMATION_DEFAULT_COPY_1_D:
      '... te enviamos un enlace de confirmación a {email}.*',
    WELCOME_CONFIRMATION_DEFAULT_COPY_2:
      'Te hemos enviado el enlace a {email}. *',
    WELCOME_CONFIRMATION_DEFAULT_COPY_2_C:
      'Haz clic sobre él para confirmar tu dirección de correo electrónico.',
    WELCOME_CONFIRMATION_DEFAULT_COPY_2_D:
      'Haz clic sobre él para confirmar tu registro.',
    WELCOME_CONFIRMATION_DEFAULT_HEADLINE: '¡Casi hemos terminado!',
    WELCOME_CONFIRMATION_DEFAULT_HEADLINE_C: 'Tienes un mensaje:',
    WELCOME_CONFIRMATION_DEFAULT_HEADLINE_D: 'Por tu seguridad...',
    WELCOME_CONFIRMATION_DEFAULT_SUFFIX:
      '*Consulta tu carpeta de correo basura o spam. Si utilizas Gmail, a lo mejor está en la pestaña "Promociones" o "Social".',
    WELCOME_CONFIRMATION_EDIT_EMAIL_BUTTON:
      'Enviar un nuevo enlace de inscripción',
    WELCOME_CONFIRMATION_EDIT_EMAIL_COPY: 'Si no, puedes corregirla aquí:',
    WELCOME_CONFIRMATION_EDIT_EMAIL_HEADLINE:
      '¿La dirección de correo electrónico está bien?',
    WELCOME_CONFIRMATION_EDIT_EMAIL_LABEL: 'Correo electrónico',
    WELCOME_CONFIRMATION_EDIT_EMAIL_REQUEST_ERROR:
      'Parece que se ha producido un error. Vuelve a intentarlo de nuevo.',
    WELCOME_CONFIRMATION_EMAIL_RESENT_BUTTON:
      '¿Sigues sin recibir el correo electrónico?',
    WELCOME_CONFIRMATION_EMAIL_RESENT_COPY_1:
      'Te hemos enviado un nuevo enlace de activación a: {email}',
    WELCOME_CONFIRMATION_EMAIL_RESENT_COPY_2:
      'Haz clic en el enlace de activación del mensaje de correo electrónico que has recibido para completar el proceso de inscripción.',
    WELCOME_CONFIRMATION_EMAIL_RESENT_HEADLINE: 'Ahora sí:',
    WELCOME_CONFIRMATION_PAGE_META_TITLE: 'Activar la cuenta de XING | XING',
    WELCOME_GDPR_IMG_ALT:
      'La política de privacidad de XING está en línea con el RGPD',
    WELCOME_INVITATION_HEADLINE: '{firstname} {lastname} te ha invitado.',
    WELCOME_INVITATION_SUBLINE:
      'Regístrate para aceptar la solicitud de contacto de {firstname}.',
    WELCOME_LANGUAGE_PAGE_META_TITLE: 'Seleccionar el idioma | XING',
    WELCOME_LANGUAGE_SELECT_ENGLISH_LABEL: 'English',
    WELCOME_LANGUAGE_SELECT_FRENCH_LABEL: 'Français',
    WELCOME_LANGUAGE_SELECT_GERMAN_LABEL: 'Deutsch',
    WELCOME_LANGUAGE_SELECT_HEADLINE: '¿En qué idioma quieres usar XING?',
    WELCOME_LANGUAGE_SELECT_ITALIAN_LABEL: 'Italiano',
    WELCOME_LANGUAGE_SELECT_SPANISH_LABEL: 'Español',
    WELCOME_LOGIN_FORM_EMAIL_REQUIRED_ERROR:
      'Escribe aquí tu dirección de correo electrónico.',
    WELCOME_LOGIN_FORM_FIRSTNAME_REQUIRED_ERROR: 'Escribe aquí tu nombre.',
    WELCOME_LOGIN_FORM_LASTNAME_REQUIRED_ERROR:
      'Escribe aquí tu(s) apellido(s).',
    WELCOME_LOGIN_FORM_PASSWORD_REQUIRED_ERROR: 'Escribe aquí tu contraseña.',
    WELCOME_LOGIN_FORM_PASSWORD_REQURED_ERROR: 'Escribe aquí tu contraseña.',
    WELCOME_LOGIN_FORM_REMEMEMBER_ME_LABEL: 'Seguir conectado',
    WELCOME_LOGIN_FORM_SUBMIT_REQUEST_ERROR:
      'Parece que eso no ha funcionado. Por favor, vuelve a intentarlo.',
    WELCOME_LOGIN_FORM_USERNAME_REQUIRED_ERROR:
      'Escribe aquí tu correo electrónico.',
    WELCOME_LOGIN_HEADLINE: '¡Bienvenid@ de nuevo!',
    WELCOME_LOGIN_PASSWORD_LABEL: 'Contraseña',
    WELCOME_LOGIN_PROBLEMS_LOGGING_IN: '¿No consigues iniciar una sesión?',
    WELCOME_LOGIN_SUBMIT_LABEL: 'Conectarme',
    WELCOME_LOGIN_USERNAME_LABEL: 'Correo electrónico',
    WELCOME_REGISTRATION_CTA_REG_7503_E: 'Crear un perfil nuevo',
    WELCOME_REGISTRATION_CTA_REG_7504_A: 'Siguiente',
    WELCOME_REGISTRATION_CTA_REG_7504_B: 'Registrarse',
    WELCOME_REGISTRATION_CTA_REG_7504_C: 'Registrarse ahora',
    WELCOME_REGISTRATION_CTA_REG_7504_D: 'Crear un perfil',
    WELCOME_REGISTRATION_CTA_REG_7504_E: 'Unirme a XING',
    WELCOME_REGISTRATION_DATAPROTECTION_LABEL: 'Política de privacidad',
    WELCOME_REGISTRATION_DATAPROTECTION_LINK:
      'https://privacy.xing.com/en/privacy-policy',
    WELCOME_REGISTRATION_EMAIL_LABEL: 'Correo electrónico',
    WELCOME_REGISTRATION_FIRSTNAME_LABEL: 'Nombre',
    WELCOME_REGISTRATION_HEADLINE: 'Consigue tu perfil gratuito de XING:',
    WELCOME_REGISTRATION_HEADLINE_REG_7088_B:
      '¡Regístrate gratis en tan solo 2 minutos!',
    WELCOME_REGISTRATION_HEADLINE_REG_7088_C:
      '¡Regístrate gratis en tan solo 2 minutos!',
    WELCOME_REGISTRATION_HEADLINE_REG_7088_D:
      'Regístrate ahora: ¡es gratis y solo necesitas 2 minutos!',
    WELCOME_REGISTRATION_HEADLINE_REG_7088_E:
      'Regístrate ahora: ¡es gratis y solo necesitas 2 minutos!',
    WELCOME_REGISTRATION_HEADLINE_REG_7396_B:
      'Regístrate ahora: ¡es gratis y solo necesitas 2 minutos!',
    WELCOME_REGISTRATION_HEADLINE_REG_7396_C:
      'Regístrate ahora: ¡es gratis y solo necesitas 2 minutos!',
    WELCOME_REGISTRATION_HEADLINE_REG_7396_D:
      'Regístrate ahora: ¡es gratis y solo necesitas 2 minutos!',
    WELCOME_REGISTRATION_HEADLINE_REG_7550_CMP:
      'Inscríbete ahora y usa la cuenta Premium 30 días gratis:',
    WELCOME_REGISTRATION_IGNORE_SOFT_EMAIL_ERRORS_LABEL:
      'Sí, {email} es mi dirección de correo electrónico.',
    WELCOME_REGISTRATION_LASTNAME_LABEL: 'Apellido(s)',
    WELCOME_REGISTRATION_PASSWORD_LABEL: 'Contraseña',
    WELCOME_REGISTRATION_RECAPTCHA_HEADLINE: 'Casi hemos terminado.',
    WELCOME_REGISTRATION_RECAPTCHA_PARAGRAPH:
      'Para protegerte a ti y a otros usuarios del correo basura, queremos asegurarnos de que eres una persona.',
    WELCOME_REGISTRATION_SOFT_EMAIL_ERROR:
      'Vuelve a comprobar que la dirección de correo electrónico es correcta.',
    WELCOME_REGISTRATION_SUBMIT_LABEL: 'Continuar con la confirmación',
    WELCOME_REGISTRATION_TANDC_DESCRIPTION:
      'Acepto los {tandc} y he leído la {dataprotection}.',
    WELCOME_REGISTRATION_TANDC_LABEL: 'Condiciones Generales',
    WELCOME_REGISTRATION_TIMER_CAPTCHA_BUTTON: 'Pulsar durante 5 segundos',
    WELCOME_REGISTRATION_TIMER_CAPTCHA_ERROR:
      'Lo sentimos, parece que se ha producido un error. Pulsa el botón durante 5 segundos.',
    WELCOME_REGISTRATION_TIMER_CAPTCHA_HEADLINE: '¡Una última comprobación!',
    WELCOME_REGISTRATION_TIMER_CAPTCHA_PARAGRAPH:
      'Pulsa el siguiente botón durante 5 segundos para superar nuestro control de seguridad.',
    WELCOME_REGISTRATION_VIA_CV_BAD_FILE_ERROR_LABEL:
      'No hemos podido cargar el archivo {fileName}. Puede que sea demasiado grande o que tenga un formato no compatible.',
    WELCOME_REGISTRATION_VIA_CV_BUTTON_LABEL: 'Subir CV',
    WELCOME_REGISTRATION_VIA_CV_COMMON_ERROR_LABEL:
      'Lo sentimos, se ha producido un error. Vuelve a intentarlo.',
    WELCOME_REGISTRATION_VIA_CV_DESCRIPTION_DEFAULT:
      'Sube tu currículum y completaremos automáticamente tu perfil de XING con tus datos.',
    WELCOME_REGISTRATION_VIA_CV_DESCRIPTION_SUCCESS:
      'Hemos completado tu CV automáticamente con tus datos.{br}{br} Echa un vistazo para asegurarte de que todo está bien y completa la información que falta.',
    WELCOME_REGISTRATION_VIA_CV_FILE_INFO_LABEL:
      'Formato: PDF, Word (.docx) o pages (máx. 100 MB)',
    WELCOME_REGISTRATION_VIA_CV_HEADLINE_DEFAULT: 'Gana tiempo',
    WELCOME_REGISTRATION_VIA_CV_HEADLINE_SUCCESS: 'Tu CV',
    WELCOME_SEARCHPAGE_CTA:
      'Descubre aquí tu siguiente puesto de trabajo o reencuentra a compañeros y amigos:',
    WELCOME_SEARCHPAGE_HEADLINE: 'Encuentra ofertas de empleo o usuarios:',
    WELCOME_SEARCHPAGE_JOBS_BUTTON: 'Empleo',
    WELCOME_SEARCHPAGE_JOBS_PLACEHOLDER:
      'Introducir el puesto o la palabra clave',
    WELCOME_SEARCHPAGE_MEMBERS_BUTTON: 'Miembros',
    WELCOME_SEARCHPAGE_MEMBERS_PLACEHOLDER: 'Nombre, empresa o palabra clave',
    WELCOME_SEARCHPAGE_SEARCH_BUTTON: 'Buscar',
    WELCOME_SIGNUP_FORM_SUBMIT_REQUEST_ERROR:
      'Parece que no ha funcionado. Por favor, vuelve a intentarlo.',
    WELCOME_SIGNUP_FORM_VALIDATE_RELOAD_ERROR:
      'Se ha producido un error. Por favor, habilita las cookies de tu navegador y vuelve a cargar la página.',
    WELCOME_SIGNUP_FORM_VALIDATE_REQUEST_ERROR:
      'Parece que no ha funcionado. Por favor, vuelve a intentarlo.',
    WELCOME_SIGNUP_PAGE_META_TITLE: 'Inscríbete ahora | XING',
    WELCOME_SIGNUP_USP_CONTACTS_COPY:
      'Deja que te encuentren empleadores y más de 20.000 reclutadores.',
    WELCOME_SIGNUP_USP_CONTACTS_TITLE: 'Ofertas de empleo personalizadas',
    WELCOME_SIGNUP_USP_FREE_COPY:
      'Ya como miembro básico puedes optimizar considerablemente tu búsqueda de empleo.',
    WELCOME_SIGNUP_USP_FREE_TITLE: 'Benefíciate se sin costes',
    WELCOME_SIGNUP_USP_PRESENCE_COPY:
      'Descubre con XING el trabajo que va realmente contigo.',
    WELCOME_SIGNUP_USP_PRESENCE_TITLE: 'Más de un millón  de ofertas',
    WELCOME_SIGNUP_USP_SECURITY_COPY:
      'Haz nuevos contactos y consigue ideas para mejorar tu vida laboral.',
    WELCOME_SIGNUP_USP_SECURITY_TITLE: '21 millones de miembros',
    WELCOME_SIGNUP_USPS_TITLE: 'XING – La red de empleo',
    WELCOME_STARTPAGE_APP_STORE_BADGE_ALT: 'Descargar en la App Store',
    WELCOME_STARTPAGE_CULTURE_CHECK_BUTTON: 'Ir al análisis cultural',
    WELCOME_STARTPAGE_CULTURE_CHECK_IMG_ALT:
      'Gráfico del análisis de la cultura corporativa',
    WELCOME_STARTPAGE_CULTURE_CHECK_TEXT:
      '¿Qué prefieres: jerarquías planas o instrucciones claras? Hay muchos factores que influyen en la cultura empresarial, y puedes averiguar cuáles son los que más te importan. Así sabrás qué buscar en tu próximo trabajo. Comprueba ahora el análisis cultural:',
    WELCOME_STARTPAGE_CULTURE_CHECK_TITLE:
      'Encuentra el mejor lugar de trabajo para ti.',
    WELCOME_STARTPAGE_CULTURE_COMPASS_BUTTON: 'Ver la brújula cultural',
    WELCOME_STARTPAGE_CULTURE_COMPASS_IMG_ALT:
      'Un gráfico que muestra la cultura empresarial con una escala que comprende desde tradicional hasta moderna.',
    WELCOME_STARTPAGE_CULTURE_COMPASS_TEXT:
      '¿Alguna vez te has preguntado cómo son las personas que trabajan en XYZ? La brújula cultural te muestra cómo es trabajar para la empresa te interesa. Aquí averiguas si es una empresa más tradicional o moderna en su enfoque diario, el equilibrio entre vida personal y laboral y muchas cosas más.',
    WELCOME_STARTPAGE_CULTURE_COMPASS_TITLE: 'Seguir la brújula cultural',
    WELCOME_STARTPAGE_DOWNLOAD_APP_CTA:
      '¿Tienes ganas de conocer la nueva aplicación de XING?',
    WELCOME_STARTPAGE_FORM_TITLE_REG_7371_01:
      'Regístrate gratis en solo 2 minutos:',
    WELCOME_STARTPAGE_FORM_TITLE_REG_7371_02:
      'Regístrate gratis en solo 2 minutos:',
    WELCOME_STARTPAGE_FORM_TITLE_REG_7371_03:
      'Crea tu cuenta gratuita en solo 2 minutos:',
    WELCOME_STARTPAGE_FORM_TITLE_REG_7371_04:
      'Regístrate gratis en solo 2 minutos:',
    WELCOME_STARTPAGE_GOOGLE_PLAY_BADGE_ALT: 'Ahora en Google Play',
    WELCOME_STARTPAGE_HEADER_BUTTON: 'Regístrate ya',
    WELCOME_STARTPAGE_HEADER_IMAGE_ALT:
      'Mujer feliz, reclinada en su silla de oficina',
    WELCOME_STARTPAGE_HEADER_SUBTITLE: '¡Crea tu propio XING!',
    WELCOME_STARTPAGE_HEADER_TITLE:
      '¡Ha llegado el momento de tu desarrollo laboral!',
    WELCOME_STARTPAGE_JOBS_DIRECTORY_NAVIGATION_TITLE:
      'Ofertas de empleo por letras iniciales',
    WELCOME_STARTPAGE_JOBS_VERSION_HEADER_BUTTON: 'Regístrate gratis',
    WELCOME_STARTPAGE_JOBS_VERSION_HEADER_SUBTITLE:
      'O nosotros buscamos por ti. Pruébalo:',
    WELCOME_STARTPAGE_JOBS_VERSION_HEADER_TITLE:
      'Encuentra el trabajo,{br}\nque buscas:',
    WELCOME_STARTPAGE_JOBS_VERSION_JOB_FILTER_DOGS_FRIENDLY:
      'Se admiten perros',
    WELCOME_STARTPAGE_JOBS_VERSION_JOB_FILTER_FLEXIBILITY: 'Horarios flexibles',
    WELCOME_STARTPAGE_JOBS_VERSION_JOB_FILTER_PART_TIME: 'Tiempo parcial',
    WELCOME_STARTPAGE_JOBS_VERSION_JOB_FILTER_REMOTE: 'Teletrabajo',
    WELCOME_STARTPAGE_JOBS_VERSION_JOB_INPUT_PLACEHOLDER:
      'Introducir el nombre del puesto o una palabra clave',
    WELCOME_STARTPAGE_JOBS_VERSION_LOCATION_INPUT_PLACEHOLDER: 'Lugar',
    WELCOME_STARTPAGE_JOBS_VERSION_SEARCH_SUBMIT_BUTTON: 'Encontrar un trabajo',
    WELCOME_STARTPAGE_JOBS_VERSION_SECTION_ONE_IMG_ALT:
      'Dibujo de una persona y de un CV',
    WELCOME_STARTPAGE_JOBS_VERSION_SECTION_ONE_TEXT:
      'Ya sea por una mudanza, un cambio personal o simplemente tus ganas de encontrar algo nuevo: XING te ayuda alcanzar tus metas profesionales, sin perderte por el camino. ¡Muéstrate tal y como eres!',
    WELCOME_STARTPAGE_JOBS_VERSION_SECTION_ONE_TITLE:
      'En XING eres mucho más que un currículum',
    WELCOME_STARTPAGE_JOBS_VERSION_SECTION_THREE_IMG_ALT:
      'Dibujo de una persona con una imagen en la que aparecen varias cabezas',
    WELCOME_STARTPAGE_JOBS_VERSION_SECTION_THREE_TEXT:
      'En XING, más de 20.000 reclutadores y reclutadoras están a un simple mensaje de distancia. Conoce a auténticos expertos en recursos humanos, de tu sector y del mercado laboral, y ponte en contacto con reclutadores(as) y trabajadores(as) de la empresa que te interesa. ¡Únete a ellos, únete a XING! ',
    WELCOME_STARTPAGE_JOBS_VERSION_SECTION_THREE_TITLE:
      'Habla con las personas indicadas',
    WELCOME_STARTPAGE_JOBS_VERSION_SECTION_TWO_IMG_ALT:
      'Dibujo de una persona con sombreros o cascos correspondientes a diferentes profesiones',
    WELCOME_STARTPAGE_JOBS_VERSION_SECTION_TWO_TEXT:
      'Aquí encuentras las mejores ofertas de empleo y recibes las recomendaciones indicadas en el momento oportuno. Para descubrir qué te motiva. Para seguir formándote. Para conocer empleadores interesantes, con la cultura empresarial que te gusta.',
    WELCOME_STARTPAGE_JOBS_VERSION_SECTION_TWO_TITLE:
      '1,4 millones de ofertas y un sinfín de oportunidades',
    WELCOME_STARTPAGE_JOBSFINDER_CTA_BUTTON: 'Regístrate',
    WELCOME_STARTPAGE_JOBSFINDER_CTA_TEXT:
      '¿Cómo afectan el lugar y el sector laboral en el salario? Averígualo en XING.',
    WELCOME_STARTPAGE_JOBSFINDER_IMG_ALT:
      'Una mujer intenta trabajar en una postura incómoda',
    WELCOME_STARTPAGE_JOBSFINDER_SUBTITLE: 'Sé tú mismo/a:',
    WELCOME_STARTPAGE_JOBSFINDER_SUGGESTION_CONSULTING: 'Consultoría',
    WELCOME_STARTPAGE_JOBSFINDER_SUGGESTION_IT: 'Tecnologías de la información',
    WELCOME_STARTPAGE_JOBSFINDER_SUGGESTION_LOGISTICS: 'Logística',
    WELCOME_STARTPAGE_JOBSFINDER_SUGGESTION_MARKETING: 'Marketing',
    WELCOME_STARTPAGE_JOBSFINDER_SUGGESTION_MORE_JOBS: 'Más sectores',
    WELCOME_STARTPAGE_JOBSFINDER_SUGGESTION_PROJECT_MANAGEMENT:
      'Gestión de proyectos',
    WELCOME_STARTPAGE_JOBSFINDER_TITLE: 'Encuentra el trabajo que buscas.',
    WELCOME_STARTPAGE_KEY_FEATURES_EVENTS: '1,7 millones de eventos',
    WELCOME_STARTPAGE_KEY_FEATURES_JOBS: 'Más de 250.000 ofertas de empleo',
    WELCOME_STARTPAGE_KEY_FEATURES_MEMBERS: '20 millones de usuarios',
    WELCOME_STARTPAGE_KEY_FEATURES_NEWS: 'Noticias del sector todos los días',
    WELCOME_STARTPAGE_MAIN_CTA_BUTTON: 'Regístrate gratis',
    WELCOME_STARTPAGE_MAIN_CTA_TEXT:
      'XING: la mayor red profesional en los países de habla germana.',
    WELCOME_STARTPAGE_MAIN_DESCRIPTION:
      'XING es tu asistente personal para tu vida laboral. Establece contactos profesionales y descubre trabajos interesantes y noticias especializadas.',
    WELCOME_STARTPAGE_MAIN_DESCRIPTION_REG_7088_B:
      'Encuentra el trabajo que mejor se ajusta a ti.',
    WELCOME_STARTPAGE_MAIN_DESCRIPTION_REG_7088_C:
      'Un mismo lugar con muchas personas interesantes. Descubre las novedades más actuales, comparte ideas y busca inspiración en XING.',
    WELCOME_STARTPAGE_MAIN_DESCRIPTION_REG_7088_D:
      'Averigua qué hay de nuevo entre tus compañeros, mantente en contacto  y habla sobre lo que te apasiona con quienes comparten tus intereses.',
    WELCOME_STARTPAGE_MAIN_DESCRIPTION_REG_7088_E:
      'Un mismo lugar con muchas personas. Comparte ideas, busca inspiración y descubre las novedades más actuales en XING.',
    WELCOME_STARTPAGE_MAIN_SUBTITLE_REG_7494:
      'Für Dein Leben. Für Deinen Job. Für Dein Job-Leben.',
    WELCOME_STARTPAGE_MAIN_TITLE: 'XING - Ideas para una nueva vida laboral',
    WELCOME_STARTPAGE_MAIN_TITLE_REG_7088_B: 'Encuentra el trabajo que buscas',
    WELCOME_STARTPAGE_MAIN_TITLE_REG_7088_C:
      'Usa tu red de contactos y llega más lejos.',
    WELCOME_STARTPAGE_MAIN_TITLE_REG_7088_D:
      '¿Tu carrera profesional? Es cuestión de contactos.',
    WELCOME_STARTPAGE_MAIN_TITLE_REG_7088_E:
      'Conoce a las personas clave para tu carrera profesional.',
    WELCOME_STARTPAGE_MAIN_TITLE_REG_7371_01:
      'Vive mejor, trabaja mejor: con el trabajo que mejor te va.',
    WELCOME_STARTPAGE_MAIN_TITLE_REG_7371_02:
      'No lo pospongas más, encuentra el trabajo perfecto para ti.',
    WELCOME_STARTPAGE_MAIN_TITLE_REG_7371_03: 'XING: tu aliado profesional.',
    WELCOME_STARTPAGE_MAIN_TITLE_REG_7371_04:
      'Vive mejor, trabaja mejor: con el trabajo que mejor te va.',
    WELCOME_STARTPAGE_MAIN_TITLE_REG_7494: 'Weil Du’s Dir vorgenommen hast.',
    WELCOME_STARTPAGE_MAIN_TITLE_REG_7747:
      'Ha llegado el momento de ser tú mismo(a).{br}\n¡Crea tu propio XING!',
    WELCOME_STARTPAGE_MEMBER_DIRECTORY_NAVIGATION_TITLE:
      'Miembros por iniciales',
    WELCOME_STARTPAGE_META_DESCRIPTION:
      'XING es tu acompañante personal en la vida laboral. Establece contactos profesionales, descubre trabajos interesantes y obtén valiosos consejos para tu vida laboral.',
    WELCOME_STARTPAGE_META_DESCRIPTION_JOB_SEARCH:
      '✓ Análisis cultural ✓ Evaluaciones de empleadores ✓ e-Learning ✓ Contacto con reclutadores - Crea tu propio XING para disfrutar de tu trabajo e incrementar tu satisfacción laboral',
    WELCOME_STARTPAGE_META_TITLE: 'XING - Mejora tu vida laboral',
    WELCOME_STARTPAGE_META_TITLE_JOB_SEARCH:
      'XING - Encuentra el trabajo que de verdad te va.',
    WELCOME_STARTPAGE_OG_SITENAME: 'XING',
    WELCOME_STARTPAGE_OG_TITLE: 'XING – Ideas para un nuevo mundo profesional',
    WELCOME_STARTPAGE_PROCEED_WITH_APPLE_BUTTON: 'Seguir con Apple',
    WELCOME_STARTPAGE_PROCEED_WITH_GOOGLE_BUTTON: 'Seguir con Google',
    WELCOME_STARTPAGE_XINGGUIDE_BUTTON: 'Ver más',
    WELCOME_STARTPAGE_XINGGUIDE_IMG_ALT:
      'Un mensaje de XING Guide, con una oferta de empleo recomendada',
    WELCOME_STARTPAGE_XINGGUIDE_TEXT:
      '¿Buscas empleo o empiezas un trabajo nuevo? Esta guía te ayudará con consejos sobre cómo mejorar tu presencia en XING: desde la optimización de tu perfil hasta recomendaciones de contactos o artículos interesantes, en función de lo que necesitas.',
    WELCOME_STARTPAGE_XINGGUIDE_TITLE: 'Tu mayor apoyo profesional',
    WELCOME_TOGGLE_FORM_BUTTON_LOGIN: 'Iniciar sesión',
    WELCOME_TOGGLE_FORM_BUTTON_REGISTER: 'Registrarme',
    XAM_GENERIC_ERROR_MESSAGE:
      'Se ha producido un error. Por favor, vuelve a intentarlo más tarde.',
    XAM_LEAD_AD_CUSTOM_QUESTION_PLACEHOLDER: 'Introduce tu respuesta.',
    XAM_LEAD_AD_FORM_THANKS_CTA_DOWNLOAD_NOW: 'Download now',
    XAM_LEAD_AD_FORM_THANKS_CTA_TRY_NOW: 'Try now',
    XAM_LEAD_AD_FORM_THANKS_CTA_VISIT_COMPANY_WEBSITE: 'Visit company website',
    XAM_LEAD_AD_FORM_THANKS_CTA_VISIT_NOW: 'Visit now',
    XAM_LEAD_AD_FORM_THANKS_CTA_VISIT_XING_PAGE: 'Visit XING page',
    XAM_LEAD_AD_PREVIEW_CONFIRMATION_SUCCESS_MESSAGE: 'Solicitud enviada',
    XAS_ARMSTRONG_LEAD_AD_FORM_THANKS_BUTTON_COPY: 'Ver la página de XING',
    XDS_EMPTYSTATE_ERROR_BUTTON: 'Volver a intentar',
    XDS_EMPTYSTATE_ERROR_DESCRIPTION: 'Por favor, vuelve a intentarlo.',
    XDS_EMPTYSTATE_ERROR_TITLE: 'Parece que se ha producido un error.',
  },
};
